/**
 * EVConfigForm - Electric Vehicle configuration form.
 */

import { Stack, NumberInput, Select } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import type { ProsumerFormValues } from '../../types';

export interface EVConfigFormProps {
  form: UseFormReturnType<ProsumerFormValues>;
}

export function EVConfigForm({ form }: EVConfigFormProps) {
  return (
    <Stack gap="sm">
      <NumberInput
        label="Roczny przebieg (km)"
        min={5000}
        max={50000}
        step={1000}
        value={form.values.evConfig.annualMileageKm}
        onChange={(val) => form.setFieldValue('evConfig.annualMileageKm', typeof val === 'number' ? val : 15000)}
      />

      <NumberInput
        label="Zużycie pojazdu"
        description="Sprawdź w dokumentacji pojazdu (np. BMW i3: 17, Tesla Model 3: 15, VW ID.3: 16, Hyundai Ioniq 5: 18). Zimą wzrasta o ~20%."
        suffix=" kWh/100 km"
        min={10}
        max={35}
        step={0.5}
        value={form.values.evConfig.consumptionKwhPer100km}
        onChange={(val) => form.setFieldValue('evConfig.consumptionKwhPer100km', typeof val === 'number' ? val : 18)}
      />

      <Select
        label="Wzorzec ładowania"
        data={[
          { value: 'NIGHT', label: 'Nocne' },
          { value: 'EVENING', label: 'Wieczorne' },
          { value: 'WEEKEND', label: 'Weekendowe' },
          { value: 'DAYTIME', label: 'Dzienne' },
          { value: 'MIXED', label: 'Mieszane' },
        ]}
        value={form.values.evConfig.chargingPattern}
        onChange={(val) => val && form.setFieldValue('evConfig.chargingPattern', val as any)}
      />

      <Select
        label="Moc ładowarki (kW)"
        data={[
          { value: '3.6', label: '3.6 kW' },
          { value: '7.2', label: '7.2 kW' },
          { value: '11', label: '11 kW' },
          { value: '22', label: '22 kW' },
        ]}
        value={String(form.values.evConfig.chargerPowerKw)}
        onChange={(val) => val && form.setFieldValue('evConfig.chargerPowerKw', parseFloat(val))}
      />
    </Stack>
  );
}
